<div
  class="date-editor"
  [class.date-editor--compact]="compact()"
  [class.date-editor--form]="appearance() === 'form'"
  [class.date-editor--error]="hasError()"
>
  <div
    class="input-wrapper"
    cdkOverlayOrigin
    #calendarOrigin="cdkOverlayOrigin"
    [class.input-wrapper--with-calendar]="showCalendarIcon()"
  >
    <input
      #inputElement
      matInput
      type="text"
      [attr.aria-label]="placeholder()"
      autocomplete="off"
      [value]="inputValue()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      [style.width.px]="widthPx()"
      [style.height.px]="heightPx()"
      [attr.aria-invalid]="hasError()"
      (focus)="onFocus()"
      (click)="openCalendar()"
      (input)="onInput($event)"
      (keydown)="onKeyDown($event)"
      (blur)="validateAndFormatInput()"
      (keydown.enter)="validateAndFormatInput()"
      data-testid="date-picker-input"
    />

    @if (showCalendarIcon()) { @if (inputValue()) {
    <button
      type="button"
      class="clear-icon date-editor__calendar-clear-icon"
      [attr.aria-label]="clearDateLabel"
      data-testid="date-picker-calendar-clear-icon"
      (mousedown)="$event.preventDefault(); $event.stopPropagation()"
      (click)="clearCalendarInput($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
    }
    <button
      type="button"
      class="date-editor__icon-button date-editor__calendar-button"
      aria-label="Open calendar"
      [disabled]="disabled()"
      [attr.aria-expanded]="isCalendarOpen()"
      data-testid="date-picker-calendar-button"
      (mousedown)="$event.preventDefault()"
      (click)="openCalendarFromIcon($event)"
    >
      <img
        src="images/calendar.svg"
        alt="calendar"
        class="date-editor__calendar-icon"
      />
    </button>
    } @else{
    <mat-icon
      class="clear-icon"
      tabindex="0"
      role="button"
      [attr.aria-label]="clearDateLabel"
      data-testid="date-picker-clear-icon"
      (click)="clearInput($event)"
      (keydown.enter)="clearInput($event)"
    >
      close
    </mat-icon>
    }
  </div>

  @if (isCalendarOpen()) {
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="calendarOrigin"
    [cdkConnectedOverlayOpen]="isCalendarOpen()"
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayFlexibleDimensions]="false"
    [cdkConnectedOverlayViewportMargin]="8"
    [cdkConnectedOverlayPositions]="calendarPositions"
    cdkConnectedOverlayPanelClass="custom-date-picker-overlay"
    (overlayOutsideClick)="closeCalendar()"
    (detach)="closeCalendar()"
  >
    <div
      class="calendar-container calendar-popup"
      (mousedown)="$event.preventDefault(); $event.stopPropagation()"
    >
      <mat-calendar
        [selected]="selectedDate()"
        [startAt]="selectedDate()"
        [minDate]="minDate()"
        [maxDate]="maxDate()"
        (selectedChange)="onDateSelected($event)"
        data-testid="date-picker-calendar"
      >
      </mat-calendar>
    </div>
  </ng-template>

  }
</div>
